<template>
  <div class="relative">
    <input
      class="form-input"
      v-model="model"
      id="password"
      :type="type"
      :placeholder="$t('Pass')"
    />

    <OhVueIcon
      class="absolute top-0 right-0"
      @click="type = type === 'input' ? 'password' : 'input'"
      :name="type === 'input' ? 'bi-eye-slash-fill' : 'bi-eye-fill'"
    >
      EYE
    </OhVueIcon>
  </div>
</template>
<script setup lang="ts">
import { defineModel, ref } from "vue";

import { addIcons, OhVueIcon } from "oh-vue-icons";

import { BiEyeFill, BiEyeSlashFill } from "oh-vue-icons/icons";

addIcons(BiEyeFill, BiEyeSlashFill);

const model = defineModel();
const type = ref<"input" | "password">("password");
</script>
